import { getStatusOption, StatusData } from 'src/app/constants/Status';

export interface GapItem {
  context?: string | null;
  label: string;
  missing: string[];
}

export interface GapSubgroup {
  context: string | null;
  items: GapItem[];
}

export interface GapGroup {
  key: string;
  title: string;
  count: number;
  subgroups: GapSubgroup[];
}

// Open = anything not DONE (NOT_REQUIRED included); group rows and unknown ids are skipped.
export function openTasksOf<T extends { taskId: any; status: number; type?: string }>(taskIds: any[] | null | undefined, tasks: T[]): T[] {
  return (taskIds ?? [])
    .map(id => tasks.find(t => t.taskId == id && t.status != StatusData.DONE.id))
    .filter(t => t != null && t.type != 'group');
}

export function buildExportGapGroups(
  openTasks: { title: string; status: number }[],
  preflightGroups: { section: string; title: string; items: GapItem[] }[]
): GapGroup[] {
  const groups = [
    {
      key: 'tasks',
      title: $localize`:@@exportGapsTasks:Tasks not done`,
      items: openTasks.map(t => ({ label: t.title, missing: [getStatusOption(t.status)] })),
    },
    ...preflightGroups.map(g => ({
      key: g.section,
      title: g.title,
      // A blocked contract has nothing missing; the badge says why it is listed.
      items: g.section == 'NoAccess' ? g.items.map(i => ({ ...i, missing: [$localize`:@@exportGapNotExported:Not exported`] })) : g.items,
    })),
  ];
  return groups
    .filter(g => g.items.length > 0)
    .map(g => ({ key: g.key, title: g.title, count: g.items.length, subgroups: bySubgroup(g.items) }));
}

// Rows of the same context (owner, component type) under one heading, in order of first appearance.
function bySubgroup(items: GapItem[]): GapSubgroup[] {
  const subgroups: GapSubgroup[] = [];
  for (const item of items) {
    const context = item.context || null;
    const subgroup = subgroups.find(s => s.context == context);
    if (subgroup) {
      subgroup.items.push(item);
    } else {
      subgroups.push({ context, items: [item] });
    }
  }
  return subgroups;
}
